import { useTranslation } from 'next-i18next';
import { THeader } from '@/types/translations/types';
export default function useHeaderTranslation(): THeader {
  const { t: tHeader } = useTranslation('header');

  return tHeader as THeader;
}
